import React from 'react';
import { motion } from "framer-motion";
import { useHistory } from "react-router-dom";
import { onDragEnd } from "../resources/utils";
import {
  Link,
} from "react-router-dom";

import ProductBannerCard from "../components/ProductBannerCard";
import ProductCard from "../components/ProductCard";
import TierCard from "../components/TierCard";
import Welcomer from "../components/Welcomer";

import styles from './What.module.scss';

const variants = {
  enter: {
    x: -1000,
    opacity: 0
  },
  center: {
    zIndex: 1,
    x: 0,
    opacity: 1
  },
  exit: {
    zIndex: 0,
    x: 1000,
    opacity: 0
  }
};

const What = ({ config, rewards, tiers, customer }) => {
  let history = useHistory();
  return (
    <motion.div
    className={styles.what}
    data-has-footer={customer && customer.accountEnabled}
    variants={variants}
    initial="enter"
    animate="center"
    exit="exit"
    transition={{
      x: { type: "spring", stiffness: 300, damping: 30 },
      opacity: { duration: 0.2 }
    }}
    drag="x"
    dragConstraints={{ left: 0, right: 0 }}
    dragElastic={0.5}
    onDragEnd={(e, { offset, velocity }) => {
      onDragEnd(
        offset,
        velocity,
        () => {
          history.goBack();
        },
        () => {
          // do nothing
        },
      )
    }}
    >
      {
        customer && customer.accountEnabled &&
        <Welcomer logo={config.logo} customer={customer} />
      }
      <div onClick={() => { history.goBack(); }} className={styles.breadcrumb}>
        <svg width="17" height="9" viewBox="0 0 17 9" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M5.19752 0.123583L5.46584 0.372138C5.64366 0.53688 5.64366 0.803996 5.46584 0.968773L2.28107 3.90235H16.5446C16.7961 3.90235 17 4.09124 17 4.32422V4.67579C17 4.90877 16.7961 5.09766 16.5446 5.09766H2.28107L5.46584 8.03124C5.64366 8.19598 5.64366 8.46309 5.46584 8.62787L5.19752 8.87643C5.0197 9.04117 4.73139 9.04117 4.55357 8.87643L0.133383 4.7983C-0.0444355 4.63356 -0.0444355 4.36645 0.133383 4.20167L4.55357 0.123583C4.73139 -0.0411943 5.0197 -0.0411943 5.19752 0.123583Z" fill="#1D1D1E"/>
        </svg>
        <span>What can I get?</span>
      </div>
      <span>Earn George Rewards points to upgrade your tier and spend on rewards.</span>
      <div className={styles.rewards}>
        <strong>Featured rewards</strong>
        {
          config.rewardsFeatured.map(x => {
            let rewardCard = config.rewards.find(z => z.id === x.id);
            let rewardObj = rewards.find(z => z.id === x.id);
            if(rewardCard && rewardObj) {
              if(x.banner) {
                return <ProductBannerCard key={x.id} image={x.bannerImage} title={rewardCard.title} points={rewardObj.points} id={x.id} buttonText={x.bannerButtonText} buttonColour={x.bannerButtonColour} buttonTextColour={x.bannerButtonTextColour} textColour={x.bannerTextColour }/>
              }
              return <ProductCard key={x.id} image={rewardCard.image} title={rewardCard.title} points={rewardObj.points} id={x.id} />
            } else {
              return <div key={x.id}></div>
            }
          })
        }
        <Link to="/rewards" className={styles.button}>All rewards</Link>
      </div>
      <div className={styles.tiers}>
        <strong>George Rewards tiers</strong>
        {
          config.tiers.map(x => {
            return <TierCard key={x.id} id={x.id} title={x.title} accent={x.accent} perks={x.perks} image={x.image} />
          })
        }
      </div>
    </motion.div>
  )
}

export default What;
